﻿const History = window.History;
import Chart from 'chart.js/auto'
let aseMetricPageModel;
let myLineChart = null;

function AseMetricPageModel() {
    const self = this;
    self.period = null;
    self.periodOptions = [];
    self.data = null;

    self.setCurrentPeriod = function (period) {
        for (let i = 0; i < self.periodOptions.length; i++) {
            if (self.periodOptions[i].Month === period) {
                self.period = self.periodOptions[i];
            }
        }
    }

    self.setMetricData = function (data) {
        self.data = data;
    }

    self.getMetricDatas = function (months) {
        const result = {labels: [], datasets: []};
        let monthsAdded = 0;
        for (var i = self.data.labels.length - 1; i >= 0 && monthsAdded < months; i--) {
            const label = self.data.labels[i];
            const datasetData = self.data.datasets[0].data[i];
            result.labels.push(label);
            if (!result.datasets[0]) {
                result.datasets[0] = {
                    data: []
                };
            }
            result.datasets[0].data.push(datasetData);
            result.datasets[0].backgroundColor = self.data.datasets[0].pointColor;
            result.datasets[0].borderColor = self.data.datasets[0].pointColor;
            result.datasets[0].fill = false;
            monthsAdded++;
        }
        result.labels.reverse();
        result.datasets[0].data.reverse();
        return result;
    }

    self.getData = function (selectedPeriod) {
        return {period: selectedPeriod};
    }

    function buildUpQueryString(data) {
        return "?Period=" + data.period;
    }

    self.updateUrl = function (selectedPeriod) {
        const data = self.getData(selectedPeriod);
        History.pushState(data, null, location.pathname + buildUpQueryString(data));
    };
}

function drawLineChart(count) {
    if (myLineChart) {
        myLineChart.destroy();
    }

    let scaleLabel = "<%=value/1%>%";
    const currentMetric = $('[data-metric-type]').data('metric-type');

    if (currentMetric == "AverageDealershipProfit") {

        scaleLabel = "<%=value%>";
    } else if (currentMetric == "SalesPerSalesman") {
        scaleLabel = "<%=value%>";
    } else if (currentMetric == "UsedNewSales") {
        scaleLabel = "<%=value%>:1";
    } else if (currentMetric == "UsedVehicleStockturnDays") {
        scaleLabel = "<%=value%> days";
    } else if (currentMetric == "HoursPerRetailJobCard") {
        scaleLabel = "<%=value%>";
    } else if (currentMetric == "PartsStockturn") {
        scaleLabel = "<%=value%>";
    }

    const options = {
        responsive: true,
        plugins:{
            legend: {
                display: false
            },
        }
    };

    if (currentMetric === "UsedNewSales") {
        options.scales = {
            yAxes: [{
                ticks: {
                    stepSize: 0.5,
                    suggestedMin: 0,
                    suggestedMax: 5,
                }
            }]
        };
    }

    if (currentMetric === "AverageDealershipProfit") {
        options.scales = {
            yAxes: [{
                ticks: {
                    stepSize: 20000,
                    suggestedMin: -30000,
                }
            }]
        };
    }

    const data = aseMetricPageModel.getMetricDatas(count);
    const canvas = $("#myChart").get(0);
    const ctx = canvas.getContext("2d");
    const config = {
        options: options,
        type: 'line',
        scaleLabel: scaleLabel,
        data
    };
    myLineChart = new Chart(ctx, config);
}

export function setupASEMetricPage() {
    const page = $('[data-ase-metric-page]').length;
    if (!page) {
        return;
    }
    
    aseMetricPageModel = new AseMetricPageModel();
    const periodList = $('#PeriodList');
    const periodOptions = $.parseJSON(periodList.val());
    for (let i = 0; i < periodOptions.length; i++) {
        aseMetricPageModel.periodOptions.push(periodOptions[i]);
    }

    // Populate select menu
    const periodSelect = document.getElementById('period');
    aseMetricPageModel.periodOptions.forEach(option => {
        const optElement = document.createElement('option');
        optElement.value = option.Month;
        optElement.text = option.Name;
        periodSelect.appendChild(optElement);
    });
    
    // Set the current period
    periodSelect.value = periodList.data("current-period");

    const metricData = $.parseJSON($('#MetricData').val());
    aseMetricPageModel.setMetricData(metricData);
    
    drawLineChart(periodList.data("current-period"));

    $(document).on("change", "#period", function () {
        const selectedPeriod = $(this).val();
        aseMetricPageModel.updateUrl(selectedPeriod);
        drawLineChart(selectedPeriod);
    });

    $(document).on("change", "#OtherMetricPage", function () {
        const selectedMetricPage = $(this).val();
        window.location.href = selectedMetricPage;
    });
}
